import { render, staticRenderFns } from "./ArticleAdultLayer.vue?vue&type=template&id=f63b304e&scoped=true"
import script from "./ArticleAdultLayer.vue?vue&type=script&lang=ts"
export * from "./ArticleAdultLayer.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAdultLayer.vue?vue&type=style&index=0&id=f63b304e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63b304e",
  null
  
)

export default component.exports